import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { AppMaterialModule } from './app-material/app-material.module';
import { MsalGuard } from '@azure/msal-angular';
import { LoginComponent } from './login/login/login.component';
import { HomeComponent } from './home/home/home.component';
import { HomeSaguicontrolComponent } from './home/home-saguicontrol/home-saguicontrol.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
  // Rota de login (sem layout)
  {
    path: 'login',
    component: LoginComponent,
  },
  
  // Rotas especiais para códigos de autenticação
  {
    path: 'code',
    redirectTo: '',
    pathMatch: 'full'
  },
  {
    path: 'state',
    redirectTo: '',
    pathMatch: 'full'
  },
  
  // ✅ ESTRUTURA SIMPLES: MainLayoutComponent uma vez, children diretos
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [MsalGuard],
    children: [
      // Rota raiz redireciona para home
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full'
      },
      
      // ✅ ROTAS DIRETAS COMO CHILDREN (sem barra inicial)
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'home-saguicontrol',
        component: HomeSaguicontrolComponent
      },
      
      // ✅ MÓDULOS LAZY-LOADED COMO CHILDREN
      {
        path: 'venda',
        loadChildren: () => import('./venda/venda.module').then(m => m.VendaModule)
      },
      {
        path: 'remessa',
        loadChildren: () => import('./remessa/remessa.module').then(m => m.RemessaModule)
      },
      {
        path: 'cliente',
        loadChildren: () => import('./cliente/cliente.module').then(m => m.ClienteModule)
      },
      {
        path: 'faturavenda',
        loadChildren: () => import('./fatura/fatura.module').then(m => m.FaturaModule)
      },
      {
        path: 'faturacompra',
        loadChildren: () => import('./fatura/fatura.module').then(m => m.FaturaModule)
      },
      {
        path: 'fornecedor',
        loadChildren: () => import('./fornecedor/fornecedor.module').then(m => m.FornecedorModule)
      },
      {
        path: 'centro',
        loadChildren: () => import('./centro/centro.module').then(m => m.CentroModule)
      },
      {
        path: 'produto',
        loadChildren: () => import('./produto/produto.module').then(m => m.ProdutoModule)
      },
      {
        path: 'produtos-e-servicos',
        loadChildren: () => import('./produtoeservico/servico.module').then(m => m.ServicoModule)
      },
      {
        path: 'segurancadotrabalho',
        loadChildren: () => import('./ordem-servico/ordem-servico.module').then(m => m.OrdemServicoModule)
      },
      {
        path: 'assinaturas',
        loadChildren: () => import('./assinatura/assinatura.module').then(m => m.AssinaturaModule)
      },
      {
        path: 'produtousoconsumo',
        loadChildren: () => import('./produto/produto.module').then(m => m.ProdutoModule)
      },
      {
        path: 'ativoimobilizado',
        loadChildren: () => import('./produto/produto.module').then(m => m.ProdutoModule)
      },
      {
        path: 'embalagem',
        loadChildren: () => import('./produto/produto.module').then(m => m.ProdutoModule)
      },
      {
        path: 'email',
        loadChildren: () => import('./email/email.module').then(m => m.EmailModule)
      },
      {
        path: 'compra',
        loadChildren: () => import('./compra/compra.module').then(m => m.CompraModule)
      },
      {
        path: 'veiculo',
        loadChildren: () => import('./veiculo/veiculo.module').then(m => m.VeiculoModule)
      },
      {
        path: 'empresa',
        loadChildren: () => import('./empresa/empresa.module').then(m => m.EmpresaModule)
      },
      {
        path: 'rh',
        loadChildren: () => import('./rh/rh.module').then(m => m.RhModule)
      },
      {
        path: 'financeiro',
        loadChildren: () => import('./financeiro/financeiro.module').then(m => m.FinanceiroModule)
      },
      {
        path: 'juridico',
        loadChildren: () => import('./juridico/juridico.module').then(m => m.JuridicoModule)
      },
      {
        path: 'contacorrente',
        loadChildren: () => import('./conta-corrente/conta-corrente.module').then(m => m.ContaCorrenteModule)
      },
      {
        path: 'estoque',
        loadChildren: () => import('./estoque/estoque.module').then(m => m.EstoqueModule)
      },
      {
        path: 'seguranca',
        loadChildren: () => import('./seguranca/seguranca.module').then(m => m.SegurancaModule)
      },
      {
        path: 'fiscal',
        loadChildren: () => import('./fiscal/fiscal.module').then(m => m.FiscalModule)
      },
      {
        path: 'prospect',
        loadChildren: () => import('./prospect/prospect.module').then(m => m.ProspectModule)
      },
      {
        path: 'contabil',
        loadChildren: () => import('./contabil/contabil.module').then(m => m.ContabilModule)
      },
      {
        path: 'transportadora',
        loadChildren: () => import('./transportadora/transportadora.module').then(m => m.TransportadoraModule)
      },
      {
        path: 'template',
        loadChildren: () => import('./template/template.module').then(m => m.TemplateModule)
      },
      {
        path: 'configuracao',
        loadChildren: () => import('./configuracao/configuracao.module').then(m => m.ConfiguracaoModule)
      },
      {
        path: 'crm',
        loadChildren: () => import('./crm/crm.module').then(m => m.CrmModule)
      },
      {
        path: 'pedagogico',
        loadChildren: () => import('./pedagogico/pedagogico.module').then(m => m.PedagogicoModule)
      },
      {
        path: 'diario',
        loadChildren: () => import('./diario/diario.module').then(m => m.DiarioModule)
      },
      {
        path: 'transporte',
        loadChildren: () => import('./transporte/transporte.module').then(m => m.TransporteModule)
      },
      {
        path: 'auditoria',
        loadChildren: () => import('./auditoria/auditoria.module').then(m => m.AuditoriaModule)
      },
      {
        path: 'doc',
        loadChildren: () => import('./documentacao/documentacao.module').then(m => m.DocumentacaoModule)
      }
    ]
  },
  
  // Rota wildcard - deve ser sempre a última
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { 
      useHash: true, 
      relativeLinkResolution: 'legacy' }),
    AppMaterialModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

